import { PAGES_TYPES } from 'constants/pagesTypes';

import { aboutUsExpertiseCardsSliderProps } from './aboutUsData';
import { itSupportExpertiseCardsSliderData } from './itSupportData';
import { dedicatedTeamExpertiseCardsSliderData } from './dedicatedTeamData';
import { consultingFirstExpertiseCardsSliderData } from './consultingFirstData';
import { consultingSecondExpertiseCardsSliderData } from './consultingSecondData';
import { cloudMigrationFirstExpertiseCardsSliderData } from './cloudMigrationFirstData';
import { cloudMigrationSecondExpertiseCardsSliderData } from './cloudMigrationSecondData';

export const expertiseCardsSliderPropsSelector = {
  [`${PAGES_TYPES.cloudMigration}-second`]: cloudMigrationSecondExpertiseCardsSliderData,
  [`${PAGES_TYPES.cloudMigration}-first`]: cloudMigrationFirstExpertiseCardsSliderData,
  [`${PAGES_TYPES.consulting}-second`]: consultingSecondExpertiseCardsSliderData,
  [`${PAGES_TYPES.consulting}-first`]: consultingFirstExpertiseCardsSliderData,
  [PAGES_TYPES.dedicatedTeam]: dedicatedTeamExpertiseCardsSliderData,
  [PAGES_TYPES.itSupport]: itSupportExpertiseCardsSliderData,
  [PAGES_TYPES.aboutUs]: aboutUsExpertiseCardsSliderProps,
};
